import { get } from 'lodash/fp';

export const getAttributionReportList = get('attributionReportList');
export const getReportList = get('reportList');
export const getTargetList = get('targetList');
